import { render, staticRenderFns } from "./DynamicTopMenu.vue?vue&type=template&id=5a03db73&scoped=true&"
import script from "./DynamicTopMenu.vue?vue&type=script&lang=js&"
export * from "./DynamicTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTopMenu.vue?vue&type=style&index=0&id=5a03db73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a03db73",
  null
  
)

export default component.exports